import { useState } from "react";
import { Button } from "@mantine/core";
import { McInputNew } from "../../../components";
import { doAddAdminUserToProject } from "../../projectApi";
import { useAppDispatch } from "../../../hooks";
import { setShowSuccessMessageThunk } from "../../../global/globalSlice";

export const AddUserToProject = () => {
  const dispatch = useAppDispatch();
  const [userId, setUserId] = useState<string>("");
  const [projectId, setProjectId] = useState<string>("");

  const save = async () => {
    await doAddAdminUserToProject(userId, projectId);
    dispatch(setShowSuccessMessageThunk("User added!"));
  };

  return (
    <>
      <div>
        <div>User id</div>
        <McInputNew
          style={{ width: "100%" }}
          type="text"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          name="text"
        />
        <div>Project id</div>
        <McInputNew
          style={{ width: "100%" }}
          type="text"
          value={projectId}
          onChange={(e) => setProjectId(e.target.value)}
          name="text"
        />
        <div className="d-flex align-items-center mt-2">
          <Button disabled={userId === "" || projectId === ""} color="green" onClick={save}>
            Save
          </Button>
        </div>
      </div>
    </>
  );
};
